<div (contextmenu)="false;">
    <div *ngIf="_loaderService.isLoading | async" class="progress-bar-container">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <router-outlet></router-outlet>
</div>